<script>

import ExhibitorRow from "./exhibitor-row.vue"
import ExhibitorNavbar from "./exhibitor-navbar.vue"
import FavoriteMixin from "./favorite-mixin.js"
import PaginationButtons from "../pagination-buttons.vue"

export default {
  components: {ExhibitorNavbar, ExhibitorRow, PaginationButtons},
  mixins: [FavoriteMixin],
  props: {
    eventShortName: {type: String },
    listDisplay: {type: Boolean, default: true},
    },

  data() {
    return {
      filter: {},
      activeCategoryName: null,
      currentNode: null,
      tree: null,
      loading: false,
      exhibitors: [],
      numExhibitors: 0,
      numVisitedExhibitors: 0,
      numPages: 0,
      page: this.$route.query.page || 1,
    }
  },

  computed: {
    favoriteMode() {
      return this.eventShortName == undefined && !this.$route.query.visits || !navigator.onLine
    },
    favActive() { return this.filter.favorites },
    visitsActive() { return this.filter.visits },
    itemKey() { return `${this.exhibitorType}s` }
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.filter = newValue
        this.fetchExhibitors(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        if (this.filter.company__name__gt)
          query.company__name__gt = this.filter.company__name__gt
        if (this.filter.favorites)
          query.favorites = "1"
        if (this.filter.visits)
          query.visits = true
        if (this.filter.categories__id)
          query.categories__id = this.filter.categories__id
        if (this.filter.categories && this.filter.categories.length)
          query.categories = this.filter.categories
        if (this.filter.for_me)
          query.for_me = "1"
        this.$router.push({query: query}).catch(err => {
          // catch NavigationDuplicated
          console.error(err)
        });
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchExhibitors({page: newValue, ...this.filter})
        // persist page in URL so browser-back restores it
        let query = {...this.$route.query}
        if (newValue > 1) query.page = newValue
        else delete query.page
        this.$router.replace({query}).catch(() => {})
      },
    },
  },

  created() {
    const q = this._urlQuery()

    if (q.search) this.filter.search = q.search
    if (q.company__name__gt) this.filter.company__name__gt = q.company__name__gt
    if (q.visits) this.filter.visits = true
    if (q.categories__id) this.$set(this.filter, 'categories__id', q.categories__id)
    if (q.categories) this.$set(this.filter, 'categories', Array.isArray(q.categories) ? q.categories : [q.categories])
    if (q.for_me) this.$set(this.filter, 'for_me', 1)
    if (q.page) this.page = q.page

    if (q.favorites) {
      this.filter.favorites = "1"
    } else if (this.favoriteMode) {
      this.filter.favorites = "1"
    }

    this.fetchExhibitors({page: this.page, ...this.filter})
  },

  methods: {
    onSearchChanged: function (search) {
        this.currentNode = null
        if (search) this.$set(this.filter, 'search', search)
        else this.$delete(this.filter, 'search')
    },

    toggleVisits(active) {
      if (active && !this.numVisitedExhibitors)
        return
      this.$delete(this.filter, 'favorites')
      this.$delete(this.filter, 'search')
      if (active)
        this.$set(this.filter, 'visits', active)
      else
        this.$delete(this.filter, 'visits')
    },

    resetFilter: function () {
      this.$delete(this.filter, 'search')
      this.currentNode = null
    },

    showDescription: function(exhibitor) {
      this.$set(exhibitor, 'show_desc',  exhibitor.show_desc == undefined ? 1 : !exhibitor.show_desc)
    },

    fetchExhibitors: function (filter) {
      let me =  this
      let params = {...filter}
      let payload = {}
      if (this.favoriteMode) {
        if (this.getFavorites().length < 1) {
          me.exhibitors = []
          me.numExhibitors = 0
          me.numPages = 1
          return
        }
      } else {
        if (this.eventShortName) {
          params.event__short_name = this.eventShortName.toUpperCase()
        }
        if (params.favorites) {
          delete params.favorites
          payload.sfid = this.getFavorites()
        }
      }
      if (navigator.onLine) {
        if (this.favoriteMode || params.favorites === "1") {
          payload.sfid = this.getFavorites()
          delete params.favorites
        }
        me.loading = true
        return this.$api.post(`/${this.itemKey}/`, payload, {params: params,}).then(
          response => {
          me.exhibitors = response.data.results
          me.numExhibitors = response.data.count
          me.numVisitedExhibitors = response.data.num_visited_exhibitors
          me.numPages = response.data.num_pages
          return response
        }).finally(() => { me.loading = false })
      } else {
        let exhibitors = this.$storage.getItem(this.itemKey, {})
        me.exhibitors = Object.values(exhibitors)
        me.numExhibitors = me.exhibitors.length
        me.numPages = 1
      }
    },

    exportList: function() {
      if (this.exhibitors.length > 200)
        alert('Export ist limitiert auf 200 Aussteller.')
      let sfids = this.exhibitors.map(exhibitor => exhibitor.sfid).slice(0, 200).join(',')
      const url = `${this.$backendUrl}api/print-exhibitors/?sfid=${sfids}`
      window.open(url, '_blank')
    },

    _urlQuery() {
      const params = new URLSearchParams(window.location.search)
      const fromUrl = {}
      params.forEach((v, k) => { fromUrl[k] = v })
      // Merge with route query — route query takes precedence in SPA context
      return Object.assign(fromUrl, (this.$route && this.$route.query) || {})
    },

    onCategoryClicked: function (cat) {
      this.activeCategoryName = cat.name
      this.$set(this.filter, 'categories__id', cat.id)
    },

    clearCategoryFilter: function () {
      this.activeCategoryName = null
      this.$delete(this.filter, 'categories__id')
    },

    onCategories: function (ids) {
      // manual category selection is exclusive with the "for me" filter
      this.$delete(this.filter, 'for_me')
      if (ids && ids.length)
        this.$set(this.filter, 'categories', ids)
      else
        this.$delete(this.filter, 'categories')
    },

    toggleForMe: function () {
      if (this.filter.for_me) {
        this.$delete(this.filter, 'for_me')
      } else {
        this.$delete(this.filter, 'categories')
        this.$set(this.filter, 'for_me', 1)
      }
    },

    onFilterValue: function (value) {
      this.filter.search = ''
      this.$delete(this.filter, 'search')
      if (value) {
        if (value == '#') value = '0'
        this.$set(this.filter, 'company__name__gt', value)
      } else
        this.$delete(this.filter, 'company__name__gt')
    },

  },
}
</script>

<template>
  <div>
    <exhibitor-navbar class="mb-1"
      :filter="filter"
      fav-key="sfid"
      :fav-mode="favoriteMode"
      :event-short-name="eventShortName"
      :visits-active="visitsActive"
      :num-visits="numVisitedExhibitors"
      @search="onSearchChanged($event)"
      @delete-search="resetFilter()"
      @on-filter-value="onFilterValue($event)"
      @toggle-favorites="toggleFavorites($event)"
      @toggle-visits="toggleVisits($event)"
      @categories="onCategories($event)"
      @toggle-for-me="toggleForMe()"
      @export-list="exportList()"
    />

    <ol class="breadcrumb bg-white ps-0">

      <li class="breadcrumb-item active">
        {{numFavorites}} Favoriten / {{numVisitedExhibitors}} Standbesuche / {{numExhibitors}} Treffer
      </li>
      <li v-if="this.filter.company__name__gt" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none"
         @click.prevent="onFilterValue()">
         <b>{{ this.filter.company__name__gt }}&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="favActive" class="breadcrumb-item active">
        <a class="badge badge-pill bg-warning me-1" style="text-decoration:none"
         @click.prevent="toggleFavorites()">
         <b>Favoriten&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="visitsActive" class="breadcrumb-item active">
        <a class="badge badge-pill bg-warning me-1" style="text-decoration:none"
         @click.prevent="toggleVisits()">
         <b>Standbesuche&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="filter.categories__id" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none"
         @click.prevent="clearCategoryFilter()">
         <b>{{ activeCategoryName }}&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="filter.for_me" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none"
         @click.prevent="toggleForMe()">
         <b>Für mich&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="filter.categories && filter.categories.length" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none"
         @click.prevent="onCategories([])">
         <b>Kategorien ({{ filter.categories.length }})&nbsp;</b><i class="far fa-times-circle"></i>
        </a>
      </li>
    </ol>

    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <span v-else-if="exhibitors.length > 0">
      <div v-for="exhibitor in exhibitors" :key="exhibitor.id">
        <exhibitor-row :exhibitorType="exhibitorType" :exhibitor="exhibitor"
         :listDisplay="listDisplay" @favorite-changed="getFavorites"
         @category-clicked="onCategoryClicked" />
        <hr/>
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages" />
    </span>
    <div v-else class="mb-3">
      <div class="text-center">-- keine Treffer --</div>
    </div>
  </div>

</template>

<style scoped>
.breadcrumb-item a {
  text-decoration: none;
  font-size: 90%;
}

.no-deco {
  text-decoration: none;
}
</style>